import { FileMessage, Message } from '@/interfaces/chat/chat.interface';
import { useChatStore } from '@/stores/chat-store';
import { useToast } from './useToast';

export const useChat = () => {
  const { showToast } = useToast();

  const scrollToPixel = (type: string) => {
    setTimeout(() => {
      const scrollTo = document.getElementById('chat-content');

      if (scrollTo) {
        scrollTo.scrollTop = type === 'bottom' ? scrollTo.scrollHeight : 30;
      }
    }, 100);
  };

  const scrollToBottom = () => {
    scrollToPixel('bottom');
  };

  const scrollToHeight = () => {
    scrollToPixel('mantein');
  };

  const formatMessagesByDate = (messages: Message[]): [string, Message[]][] => {
    const messagesGroup: { [key: string]: Message[] } = {};

    messages.forEach((message) => {
      // Convierte la fecha a la zona horaria local en formato "YYYY-MM-DD"
      const localDate = new Date(message.createdAt);
      const formattedDate = `${localDate.getFullYear()}-${String(localDate.getMonth() + 1).padStart(2, '0')}-${String(localDate.getDate()).padStart(2, '0')}`;
      if (!messagesGroup[formattedDate]) {
        messagesGroup[formattedDate] = [];
      }
      messagesGroup[formattedDate].push(message);
    });

    const messagesByDate: { [key: string]: Message[] } = {};
    for (const [fecha, messages] of Object.entries(messagesGroup)) {
      messagesByDate[fecha] = messages.sort((a, b) => {
        return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
      });
    }

    return Object.entries(messagesByDate).sort(([dateA], [dateB]) => {
      return new Date(dateA).getTime() - new Date(dateB).getTime();
    }) as [string, Message[]][];
  };

  const handleUploadChatImage = async (file: FileMessage, bookingId: string) => {
    const { uploadFile } = useChatStore();

    try {
      const response = await uploadFile(file, bookingId);
      if (response) {
        return response;
      }
    } catch (error) {
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    }
  };

  return { formatMessagesByDate, scrollToBottom, scrollToHeight, handleUploadChatImage };
};
